import { c as _c } from "react/compiler-runtime";
import { Badge } from '@repo/ui/primitives/Badge';
import { MaskIcon } from '@repo/ui/primitives/MaskIcon';
export const Promotional = t0 => {
  const $ = _c(4);
  const {
    text
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <MaskIcon glyph="access-alarm" size="sm" css={{
      marginTop: "[-1px]"
    }} />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      fontSize: "[13px]",
      width: {
        base: "[100%]",
        _pcMd: "auto"
      },
      py: "[6px]"
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== text) {
    t3 = <Badge colorVariant="blue" iconNode={t1} css={t2} text={text} />;
    $[2] = text;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
};